export default "__VITE_ASSET__DS5Vjh6m__"